module.exports = __webpack_public_path__ + "static/other/fit_five_game.b62f9496.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/fitFiveGame/fit_five_game.json
// module id = 2380
// module chunks = 0